/**
 * 1C-style tabular-section caption: sits above the whole card
 * (toolbar + grid), underline is text-width and theme primary.
 */
import Typography from '@mui/material/Typography'

/** Shared with Pages tabs — underline is text-width, not a full tab-bar rule. */
export const tabularCaptionSx = {
  display: 'inline-block' as const,
  fontSize: 14,
  fontWeight: 500,
  lineHeight: 1.3,
  color: 'text.primary',
  pb: 0.5,
  borderBottom: '2px solid',
}

export function TabularSectionTitle({ title }: { title: string }) {
  return (
    <Typography
      data-tabular-section-title
      data-testid="tabular-section-title"
      component="div"
      sx={{
        ...tabularCaptionSx,
        mb: 1,
        borderColor: 'primary.main',
      }}
    >
      {title}
    </Typography>
  )
}
